export const inspectionConfig = {
  // 金属检测
  orders: [
    {
      type: 'header',
      leftProp: '',
      leftLabel: '委托单编号：',
      rightProp: '',
      rightLabel: '申请时间：',
      titleProp: '',
    },
    {
      label: '部件/管线名称',
      prop: 'prBaseName',
      col: 6,
    },
    {
      label: '部件/管线编号',
      prop: '',
      col: 6,
    },
    {
      label: '机组类别',
      prop: 'prGroupType',
      col: 6,
    },
    {
      label: '检验类别',
      prop: '',
      col: 6,
    },
    {
      type: 'attachment',
      label: '单线图附件',
      prop: 'prSingleLineDiagramFile',
      col: 6,
    },
    {
      label: '施工单位',
      prop: 'prBuildUnitName',
      col: 6,
    },
    {
      label: '申请人',
      prop: 'prApplyUserName',
      col: 6,
    },
    {
      label: '电话',
      prop: 'prPhone',
      col: 6,
    },
    {
      label: '委托日',
      prop: 'prEntrustDate',
      col: 6,
    },
    {
      label: '预完成日',
      prop: 'prPlanCompleteDate',
      col: 6,
    },
    {
      label: '检验条件',
      prop: 'prTestCondition',
      col: 24,
    },
    {
      label: '设计温度(℃)',
      prop: 'prDesignTemperature',
      col: 6,
    },
    {
      label: '设计压力(MPa)',
      prop: 'prDesignPressure',
      col: 6,
    },
    {
      label: '总部件数量',
      prop: 'prTotalNum',
      col: 6,
    },
    {
      label: '总部件编号',
      prop: 'prTotalCode',
      col: 6,
    },
    {
      label: '检验单位',
      prop: 'prTestUnitName',
      col: 6,
    },
    {
      label: '检验负责人',
      prop: 'prTestLeader',
      col: 6,
    },
    {
      type: 'table',
      label: '',
      prop: '',
      tableHead: [
        {
          label: '检测方法',
          prop: '',
        },
        {
          label: '验收规程',
          prop: '',
        },
        {
          label: '检测标准',
          prop: '',
        },
        {
          label: '技术等级',
          prop: '',
        },
        {
          label: '技术等级',
          prop: '',
        },
        {
          label: '合格级别',
          prop: '',
        },
      ],
    },
    {
      type: 'title',
      prop: '检测项目',
    },
    {
      type: 'table',
      label: '',
      prop: '',
      tableHead: [
        {
          label: '分部件名称',
          prop: '',
        },
        {
          label: '材质',
          prop: '',
        },
        {
          label: '规格(mm)',
          prop: '',
        },
        {
          label: '坡口形式',
          prop: '',
        },
        {
          label: '焊接方法',
          prop: '',
        },
        {
          label: '焊丝牌号',
          prop: '',
        },
        {
          label: '焊条牌号',
          prop: '',
        },
        {
          label: '检测方法',
          prop: '',
        },
        {
          label: '部件总数',
          prop: '',
        },
        {
          label: '检测比例',
          prop: '',
        },
        {
          label: '检测数量',
          prop: '',
        },
        {
          label: '检测部件编号',
          prop: '',
        },
      ],
    },
    {
      type: 'title',
      prop: '验收项目及签证',
    },
    {
      type: 'table',
      label: '',
      prop: '',
      tableHead: [
        {
          label: '检测方法',
          prop: '',
        },
        {
          label: '实际检测数量',
          prop: '',
        },
      ],
    },
    {
      label: '检测结果说明',
      prop: '',
    },
    {
      label: '填写说明',
      prop: 'prInputDescription',
    },
  ],
  task: [
    {
      type: 'header',
      leftProp: '',
      leftLabel: '任务单编号：',
      rightProp: '',
      rightLabel: '任务单时间：',
      titleProp: '',
    },
    {
      label: '工程名称',
      prop: 'prProjectName',
      col: 6,
    },
    {
      label: '部件/管线名称',
      prop: 'prBaseName',
      col: 6,
    },
    {
      label: '管线单线图编号',
      prop: '',
      col: 6,
    },
    {
      type: 'attachment',
      label: '单线图附件',
      prop: 'prSingleLineDiagramFile',
      col: 6,
    },
    {
      label: '机组类别',
      prop: 'prGroupType',
      col: 6,
    },
    {
      label: '检验类别',
      prop: '',
      col: 6,
    },
    {
      label: '检测方法',
      prop: 'prTestMethod',
      col: 6,
    },
    {
      label: '总部件数量',
      prop: 'prTotalNum',
      col: 6,
    },
    {
      label: '总部件编号   ',
      prop: 'prTotalCode',
      col: 6,
    },
    {
      label: '委托单编号',
      prop: 'prMetalTestEntrustCode',
      col: 24,
    },
    {
      type: 'title',
      prop: '操作指导书',
    },
    {
      type: 'table',
      label: '',
      prop: '',
      tableHead: [
        {
          label: '#',
          prop: '',
          type: 'index',
        },
        {
          label: '操作指导书编号',
          prop: '',
        },
        {
          label: '工件名称',
          prop: '',
        },
        {
          type: 'operation',
          label: '操作',
          width: 200,
          operation: [
            {
              type: 'download',
              label: '下载指导书',
              prop: '',
            },
            {
              type: 'download',
              label: '下载原始记录表',
              prop: '',
            },
          ],
        },
      ],
    },
    {
      type: 'title',
      prop: '检测项目',
    },
    {
      type: 'table',
      label: '',
      prop: '',
      tableHead: [
        {
          label: '分部件名称',
          prop: '',
        },
        {
          label: '材质',
          prop: '',
        },
        {
          label: '规格(mm)',
          prop: '',
        },
        {
          label: '坡口形式',
          prop: '',
        },
        {
          label: '焊接方法',
          prop: '',
        },
        {
          label: '焊丝牌号',
          prop: '',
        },
        {
          label: '焊条牌号',
          prop: '',
        },
        {
          label: '焊工代号',
          prop: '',
        },
        {
          label: '部件总数',
          prop: '',
        },
        {
          label: '检测比例',
          prop: '',
        },
        {
          label: '检测数量',
          prop: '',
        },
        {
          label: '检测部件编号',
          prop: '',
        },
        {
          label: '张、点/部件',
          prop: '',
        },
      ],
    },
    {
      label: '实际检测数量',
      prop: 'prRealTestNum',
      col: 8,
    },
    {
      label: '合格数量',
      prop: 'prGoodNum',
      col: 8,
    },
    {
      label: '不合格数量',
      prop: 'prBadNum',
      col: 8,
    },
    {
      label: '实际检测当量值',
      prop: 'prRealTestValue',
      col: 8,
    },
    {
      label: '合格当量值',
      prop: 'prGoodValue',
      col: 8,
    },
    {
      label: '不合格当量值',
      prop: 'prBadValue',
      col: 8,
    },
    {
      label: '检测结论',
      prop: 'prTestResult',
    },
  ],
  defects: [
    {
      type: 'header',
      leftProp: '',
      leftLabel: '缺陷编号：',
      rightProp: '',
      rightLabel: '申请时间：',
      titleProp: '',
    },
    {
      label: '检验单位',
      prop: 'prTestUnitName',
      col: 6,
    },
    {
      label: '施工单位',
      prop: 'prBuildUnitName',
      col: 6,
    },
    {
      label: '委托单编号',
      prop: '',
      col: 6,
    },
    {
      label: '工程名称',
      prop: 'prEntrustCode',
      col: 6,
    },
    {
      label: '部件/管线名称',
      prop: 'prBaseName',
      col: 6,
    },
    {
      label: '部件/管线编号',
      prop: '',
      col: 6,
    },
    {
      label: '机组类别',
      prop: 'prGroupType',
      col: 6,
    },
    {
      label: '检验类别',
      prop: '',
      col: 6,
    },
    {
      label: '发现日期',
      prop: 'prFindDate',
      col: 6,
    },
    {
      label: '缺陷处理专业',
      prop: 'prHandlingProfession',
      col: 6,
    },
    {
      label: '缺陷数量',
      prop: '',
      col: 6,
    },
    {
      label: '检验单位-发现问题简述',
      prop: 'prTestUnitFindQuestion',
      col: 24,
    },
    {
      type: 'image',
      label: '缺陷附件',
      prop: '',
    },
    {
      label: '检验单位-原因分析',
      prop: 'prTestUnitFindReason',
      col: 24,
    },
    {
      label: '检验单位-处理意见',
      prop: 'prTestUnitFindHandle',
      col: 24,
    },
    {
      label: '检验单位-处理情况描述或意见',
      prop: 'prBuildUnitHandle',
      col: 24,
    },
    {
      label: '检验单位-处理过程检验描述',
      prop: 'prTestUnitFindProcess',
      col: 24,
    },
    {
      label: '检验单位-验收检测结果描述',
      prop: 'prTestUnitFindAcceptance',
      col: 24,
    },
    {
      type: 'title',
      prop: '实际检测数量',
    },
    {
      type: 'table',
      label: '',
      prop: '',
      tableHead: [
        {
          label: '#',
          prop: '',
          type: 'index',
        },
        {
          label: '检测方法',
          prop: '',
        },
        {
          label: '实际检测数量',
          prop: '',
        },
      ],
    },
    {
      label: '填写说明',
      prop: 'prInputDescription',
    },
  ],
  instruction: [
    {
      label: '指导书编号',
      prop: '',
      col: 12,
    },
    {
      label: '委托单编号',
      prop: '',
      col: 12,
    },
    {
      label: '工程名称',
      prop: '',
      col: 12,
    },
    {
      label: '工艺规程及其版本号',
      prop: '',
      col: 12,
    },
    {
      label: '委托单位',
      prop: '',
      col: 24,
    },
    {
      type: 'dividingLine',
      prop: '工件参数',
    },
    {
      label: '工件名称',
      prop: '',
      col: 12,
    },
    {
      label: '焊接方法',
      prop: '',
      col: 12,
    },
    {
      label: '热处理状态',
      prop: '',
      col: 12,
    },
    {
      label: '表面状态',
      prop: '',
      col: 12,
    },
    {
      label: '检测部位',
      prop: '',
      col: 12,
    },
    {
      label: '承压设备类别',
      prop: '',
      col: 12,
    },
    {
      label: '检测比例',
      prop: '',
      col: 12,
    },
    {
      type: 'dividingLine',
      prop: '技术要求',
    },
    {
      label: '检测标准',
      prop: '',
      col: 12,
    },
    {
      label: '合格级别',
      prop: '',
      col: 12,
    },
    {
      label: '技术等级',
      prop: '',
      col: 12,
    },
    {
      label: '验收流程',
      prop: '',
      col: 12,
    },
    {
      label: '底片观察技术',
      prop: '',
      col: 12,
    },
    {
      type: 'dividingLine',
      prop: '检测示意图(布片图)',
    },
    {
      label: '仪器名称',
      prop: '',
      col: 12,
    },
    {
      label: '仪器型号',
      prop: '',
      col: 12,
    },
    {
      label: '仪器编号',
      prop: '',
      col: 12,
    },
    {
      label: '焦点尺寸',
      prop: '',
      col: 12,
    },
    {
      label: '胶片等级',
      prop: '',
      col: 12,
    },
    {
      label: '胶片规格',
      prop: '',
      col: 12,
    },
    {
      label: '胶片型号',
      prop: '',
      col: 12,
    },
    {
      label: '增感屏种类',
      prop: '',
      col: 12,
    },
    {
      label: '增感屏厚度',
      prop: '',
      col: 12,
    },
    {
      label: '背散射屏蔽铅版',
      prop: '',
      col: 12,
    },
    {
      label: '滤光板',
      prop: '',
      col: 12,
    },
    {
      label: '增感屏数量',
      prop: '',
      col: 12,
    },
    {
      type: 'dividingLine',
      prop: '工艺参数',
    },
    {
      label: '规格',
      prop: '',
      col: 12,
    },
    {
      label: '材质',
      prop: '',
      col: 12,
    },
    {
      label: '坡口形式',
      prop: '',
      col: 12,
    },
    {
      label: '检测时机',
      prop: '',
      col: 12,
    },
    {
      label: '透照厚度',
      prop: '',
      col: 12,
    },
    {
      label: '透照技术',
      prop: '',
      col: 12,
    },
    {
      label: '焦距',
      prop: '',
      col: 12,
    },
    {
      label: '射线源至工件距离',
      prop: '',
      col: 12,
    },
    {
      label: '工件至胶片距离',
      prop: '',
      col: 12,
    },
    {
      label: '管电压kV',
      prop: '',
      col: 12,
    },
    {
      label: '管电流/源强度',
      prop: '',
      col: 12,
    },
    {
      label: '曝光时间',
      prop: '',
      col: 12,
    },
    {
      label: '透照次数',
      prop: '',
      col: 12,
    },
    {
      label: '有效长度',
      prop: '',
      col: 12,
    },
    {
      label: '像质计种类及型号',
      prop: '',
      col: 12,
    },
    {
      label: '应识别丝号',
      prop: '',
      col: 12,
    },
    {
      label: '像质计放置及数量',
      prop: '',
      col: 12,
    },
    {
      label: '识别/定位标记放置',
      prop: '',
      col: 12,
    },
    {
      label: '底片黑度',
      prop: '',
      col: 12,
    },
    {
      label: 'K值',
      prop: '',
      col: 12,
    },
    {
      type: 'dividingLine',
      prop: '暗室处理',
    },
    {
      label: '显影条件',
      prop: '',
      col: 12,
    },
    {
      label: '定影条件',
      prop: '',
      col: 12,
    },
    {
      label: '洗片方式',
      prop: '',
      col: 12,
    },
    {
      type: 'dividingLine',
      prop: '检测示意图(布片图)',
    },
    {
      type: 'image',
      label: '检测示意图',
      prop: '',
    },
    {
      label: '备注',
      prop: '',
      col: 24,
    },
  ],
  report: [
    {
      type: 'header',
      leftProp: '',
      leftLabel: '任务单编号：',
      rightProp: '',
      rightLabel: '任务单时间：',
      titleProp: '',
      titleLabel: '金属检验任务单',
    },
    {
      label: '工程名称',
      prop: 'prProjectname',
      col: 6,
    },
    {
      label: '部件/管线名称',
      prop: 'prBasename',
      col: 6,
    },
    {
      label: '管线单线图编号',
      prop: 'prBasecode',
      col: 6,
    },
    {
      type: 'attachment',
      label: '单线图附件',
      prop: '',
      col: 6,
    },
    {
      label: '机组类别',
      prop: 'prGrouptype',
      col: 6,
    },
    {
      label: '检验类别',
      prop: '',
      col: 6,
    },
    {
      label: '检测方法',
      prop: 'prTestmethod',
      col: 6,
    },
    {
      label: '总部件数量',
      prop: '',
      col: 6,
    },
    {
      label: '总部件编号',
      prop: '',
      col: 6,
    },
    {
      label: '委托单编号',
      prop: '',
      col: 24,
    },
    {
      type: 'title',
      prop: '操作指导书',
    },
    {
      type: 'table',
      label: '',
      prop: '',
      tableHead: [
        {
          label: '#',
          prop: '',
          type: 'index',
        },
        {
          label: '操作指导书编号',
          prop: '',
        },
        {
          label: '工件名称',
          prop: '',
        },
        {
          type: 'operation',
          label: '操作',
          width: 200,
          operation: [
            {
              type: 'download',
              label: '下载指导书',
              prop: '',
            },
            {
              type: 'download',
              label: '下载原始记录表',
              prop: '',
            },
          ],
        },
      ],
    },
    {
      type: 'title',
      prop: '检测项目',
    },
    {
      type: 'table',
      label: '',
      prop: '',
      tableHead: [
        {
          label: '分部件名称',
          prop: '',
        },
        {
          label: '材质',
          prop: '',
        },
        {
          label: '规格(mm)',
          prop: '',
        },
        {
          label: '坡口形式',
          prop: '',
        },
        {
          label: '焊接方法',
          prop: '',
        },
        {
          label: '焊丝牌号',
          prop: '',
        },
        {
          label: '焊条牌号',
          prop: '',
        },
        {
          label: '焊工代号',
          prop: '',
        },
        {
          label: '部件总数',
          prop: '',
        },
        {
          label: '检测比例',
          prop: '',
        },
        {
          label: '检测数量',
          prop: '',
        },
        {
          label: '检测部件编号',
          prop: '',
        },
        {
          label: '张、点/部件',
          prop: '',
        },
      ],
    },
    {
      label: '实际检测数量',
      prop: '',
      col: 8,
    },
    {
      label: '合格数量',
      prop: '',
      col: 8,
    },
    {
      label: '不合格数量',
      prop: '',
      col: 8,
    },
    {
      label: '实际检测当量值',
      prop: '',
      col: 8,
    },
    {
      label: '合格当量值',
      prop: '',
      col: 8,
    },
    {
      label: '不合格当量值',
      prop: '',
      col: 8,
    },
    {
      label: '检测结论',
      prop: '',
    },
  ],
  reportReorganization: [
    {
      label: '报告名称',
      prop: '',
      col: 12,
    },
    {
      label: '检验单位',
      prop: 'prTestUnitName',
      col: 12,
    },
    {
      label: '工程',
      prop: 'prProjectName',
      col: 12,
    },
    {
      type: 'table',
      label: '',
      prop: '',
      tableHead: [
        {
          label: '检测方法',
          prop: '',
        },
        {
          label: '任务来源',
          prop: '',
        },
        {
          label: '部件/管线名称',
          prop: '',
        },
        {
          label: '机组类别',
          prop: '',
        },
        {
          label: '检验类别',
          prop: '',
        },
        {
          label: '委托单编号',
          prop: '',
        },
      ],
    },
  ],
  sampling: [
    {
      label: '工程名称',
      prop: 'prProjectName',
      col: 12,
    },
    {
      label: '机组类别',
      prop: 'prGroupType',
      col: 12,
    },
    {
      label: '编号',
      prop: 'prSerialNo',
      col: 12,
    },
    {
      label: '委托单位',
      prop: 'prEntrustUnit',
      col: 12,
    },
    {
      label: '委托人',
      prop: 'prEntrustor',
      col: 12,
    },
    {
      label: '联系电话',
      prop: 'prEntrustorTel',
      col: 12,
    },
    {
      label: '检验单位',
      prop: 'prInspectUnit',
      col: 12,
    },
    {
      label: '委托日期',
      prop: '',
      col: 12,
    },
    {
      type: 'dividingLine',
      prop: '取样详情',
    },
    {
      type: 'table',
      label: '',
      prop: '',
      tableHead: [
        {
          type: 'index',
          label: '序号',
          prop: '',
        },
        {
          label: '取样名称',
          prop: '',
        },
        {
          label: '取样长度',
          prop: '',
        },
        {
          label: '取样数量',
          prop: '',
        },
        {
          label: '检验位置',
          prop: '',
        },
        {
          label: '材质',
          prop: '',
        },
        {
          label: '规格',
          prop: '',
        },
        {
          label: '检验项目',
          prop: '',
        },
        {
          label: '运行时长',
          prop: '',
        },
      ],
    },
  ],
  history: [
    {
      label: '工程名称',
      prop: 'prProjectName',
      col: 12,
    },
    {
      label: '机组类别',
      prop: 'prGroupType',
      col: 12,
    },
    {
      label: '计划名称',
      prop: 'prName',
      col: 24,
    },
    {
      label: '计划检验开始时间',
      prop: 'prBeginTime',
      col: 12,
    },
    {
      label: '计划检验结束时间',
      prop: 'prEndTime',
      col: 12,
    },
    {
      label: '检验单位',
      prop: 'prInspectUnit',
      col: 12,
    },
    {
      label: '实际检验开始时间',
      prop: 'prInspectTimeStart',
      col: 12,
    },
    {
      label: '实际检验结束时间',
      prop: 'prInspectTimeEnd',
      col: 12,
    },
  ],
  pipeline: [
    {
      label: '工程名称',
      prop: 'prProjectName',
      col: 12,
    },
    {
      label: '机组类别',
      prop: 'prGroupType',
      col: 12,
    },
    {
      label: '计划名称',
      prop: 'prName',
      col: 24,
    },
    {
      label: '计划检验开始时间',
      prop: 'prBeginTime',
      col: 12,
    },
    {
      label: '计划检验结束时间',
      prop: 'prEndTime',
      col: 12,
    },
    {
      label: '备注信息',
      prop: 'prRemarks',
      col: 24,
    },
    {
      type: 'table',
      label: '计划明细',
      prop: '',
      tableHead: [
        {
          type: 'index',
          label: '#',
          prop: '',
        },
        {
          label: '工程名称',
          prop: '',
        },
        {
          label: '部件/管线名称',
          prop: '',
        },
        {
          label: '管线单线图编号',
          prop: '',
        },
        {
          label: '机组类别',
          prop: '',
        },
        {
          label: '检验类别',
          prop: '',
        },
        {
          label: '分部件名称',
          prop: '',
        },
        {
          label: '部件编号',
          prop: '',
        },
        {
          label: '检测数量',
          prop: '',
        },
        {
          label: '检测方法',
          prop: '',
        },
        {
          type: 'operation',
          label: '操作',
          prop: '',
          operation: [
            {
              type: 'view',
              label: '查看',
              prop: '',
              formType: 'pipelineDetail',
            },
          ],
        },
      ],
    },
  ],
  pipelineDetail: [
    {
      label: '工程名称',
      prop: 'prProjectName',
      col: 12,
    },
    {
      label: '部件/管线名称',
      prop: 'prBaseName',
      col: 12,
    },
    {
      label: '管线单线图编号',
      prop: '',
      col: 12,
    },
    {
      label: '机组类别',
      prop: 'prGroupType',
      col: 12,
    },
    {
      label: '检验类别',
      prop: '',
      col: 12,
    },
    {
      label: '分部件名称',
      prop: 'prSubName',
      col: 12,
    },
    {
      label: '部件编号',
      prop: '',
      col: 12,
    },
    {
      label: '检测数量',
      prop: '',
      col: 12,
    },
    {
      label: '检测方法',
      prop: 'prTestMethod',
      col: 12,
    },
    {
      label: '备注信息',
      prop: 'prRemarks',
      col: 24,
    },
  ],
  boilerContainer: [
    {
      label: '工程名称',
      prop: 'prProjectName',
      col: 12,
    },
    {
      label: '机组',
      prop: 'prGroupType',
      col: 12,
    },
    {
      label: '计划名称',
      prop: 'prName',
      col: 24,
    },
    {
      label: '计划检验开始时间',
      prop: 'prBeginTime',
      col: 12,
    },
    {
      label: '计划检验结束时间',
      prop: 'prEndTime',
      col: 12,
    },
    {
      label: '备注信息',
      prop: 'prRemarks',
      col: 24,
    },
    {
      type: 'table',
      label: '计划明细',
      prop: '',
      tableHead: [
        {
          type: 'index',
          label: '#',
          prop: '',
        },
        {
          label: '工程名称',
          prop: '',
        },
        {
          label: '集箱名称',
          prop: '',
        },
        {
          label: '集箱编号',
          prop: '',
        },
        {
          label: '机组类别',
          prop: '',
        },
        {
          label: '检验类别',
          prop: '',
        },
        {
          label: '分部件名称',
          prop: '',
        },
        {
          label: '部件编号',
          prop: '',
        },
        {
          label: '检测数量',
          prop: '',
        },
        {
          type: 'operation',
          label: '操作',
          prop: '',
          operation: [
            {
              type: 'view',
              label: '查看',
              prop: '',
              formType: 'boilerContainerDetail',
            },
          ],
        },
      ],
    },
  ],
  boilerContainerDetail: [
    {
      label: '工程名称',
      prop: '',
      col: 12,
    },
    {
      label: '集箱名称',
      prop: '',
      col: 12,
    },
    {
      label: '集箱编号',
      prop: '',
      col: 12,
    },
    {
      label: '机组类别',
      prop: '',
      col: 12,
    },
    {
      label: '检验类别',
      prop: '',
      col: 12,
    },
    {
      label: '分部件名称',
      prop: '',
      col: 12,
    },
    {
      label: '部件编号',
      prop: '',
      col: 12,
    },
    {
      label: '检验方法',
      prop: '',
      col: 12,
    },
    {
      label: '检测数量',
      prop: '',
      col: 12,
    },
    {
      label: '备注信息',
      prop: '',
      col: 24,
    },
  ],
  heatedSurface: [
    {
      label: '工程名称',
      prop: 'prProjectName',
      col: 12,
    },
    {
      label: '机组',
      prop: 'prGroupType',
      col: 12,
    },
    {
      label: '计划名称',
      prop: 'prName',
      col: 24,
    },
    {
      label: '计划检验开始时间',
      prop: 'prBeginTime',
      col: 12,
    },
    {
      label: '计划检验结束时间',
      prop: 'prEndTime',
      col: 12,
    },
    {
      label: '备注信息',
      prop: 'prRemarks',
      col: 24,
    },
    {
      type: 'table',
      label: '计划明细',
      prop: '',
      tableHead: [
        {
          type: 'index',
          label: '#',
          prop: '',
        },
        {
          label: '工程名称',
          prop: '',
        },
        {
          label: '锅炉受热面名称',
          prop: '',
        },
        {
          label: '锅炉受热面编号',
          prop: '',
        },
        {
          label: '机组类别',
          prop: '',
        },
        {
          label: '检验类别',
          prop: '',
        },
        {
          label: '分部件名称',
          prop: '',
        },
        {
          label: '部件编号',
          prop: '',
        },
        {
          label: '检测数量',
          prop: '',
        },
        {
          type: 'operation',
          label: '操作',
          prop: '',
          operation: [
            {
              type: 'view',
              label: '查看',
              prop: '',
              formType: 'heatedSurfaceDetail',
            },
          ],
        },
      ],
    },
  ],
  heatedSurfaceDetail: [
    {
      label: '工程名称',
      prop: '',
      col: 12,
    },
    {
      label: '锅炉受热面名称',
      prop: '',
      col: 12,
    },
    {
      label: '锅炉受热面编号',
      prop: '',
      col: 12,
    },
    {
      label: '机组类别',
      prop: '',
      col: 12,
    },
    {
      label: '检验类别',
      prop: '',
      col: 12,
    },
    {
      label: '分部件名称',
      prop: '',
      col: 12,
    },
    {
      label: '部件编号',
      prop: '',
      col: 12,
    },
    {
      label: '检验方法',
      prop: '',
      col: 12,
    },
    {
      label: '检测数量',
      prop: '',
      col: 12,
    },
    {
      label: '备注信息',
      prop: '',
      col: 24,
    },
  ],
  largeCast: [
    {
      label: '工程名称',
      prop: 'prProjectName',
      col: 12,
    },
    {
      label: '机组类别',
      prop: 'prGroupType',
      col: 12,
    },
    {
      label: '计划名称',
      prop: 'prName',
      col: 24,
    },
    {
      label: '计划检验开始时间',
      prop: 'prBeginTime',
      col: 12,
    },
    {
      label: '计划检验结束时间',
      prop: 'prEndTime',
      col: 12,
    },
    {
      label: '备注信息',
      prop: 'prRemarks',
      col: 24,
    },
    {
      type: 'table',
      label: '计划明细',
      prop: '',
      tableHead: [
        {
          type: 'index',
          label: '#',
          prop: '',
        },
        {
          label: '工程名称',
          prop: '',
        },
        {
          label: '大型铸件名称',
          prop: '',
        },
        {
          label: '大型铸件编号',
          prop: '',
        },
        {
          label: '机组类别',
          prop: '',
        },
        {
          label: '分部件名称',
          prop: '',
        },
        {
          label: '部件编号',
          prop: '',
        },
        {
          label: '检测数量',
          prop: '',
        },
        {
          type: 'operation',
          label: '操作',
          prop: '',
          operation: [
            {
              type: 'view',
              label: '查看',
              prop: '',
              formType: 'largeCastDetail',
            },
          ],
        },
      ],
    },
  ],
  largeCastDetail: [
    {
      label: '工程名称',
      prop: 'prProjectName',
      col: 12,
    },
    {
      label: '大型铸件名称',
      prop: '',
      col: 12,
    },
    {
      label: '大型铸件编号',
      prop: '',
      col: 12,
    },
    {
      label: '机组类别',
      prop: 'prGroupType',
      col: 12,
    },
    {
      label: '分部件名称',
      prop: 'prDivisionName',
      col: 12,
    },
    {
      label: '部件编号',
      prop: 'prDivisionNum',
      col: 12,
    },
    {
      label: '检验方法',
      prop: 'prInspectMethod',
      col: 12,
    },
    {
      label: '检测数量',
      prop: '',
      col: 12,
    },
    {
      label: '备注信息',
      prop: 'prRemarks',
      col: 24,
    },
  ],
  highTemperatureFasteners: [
    {
      label: '工程名称',
      prop: 'prProjectName',
      col: 12,
    },
    {
      label: '机组类别',
      prop: 'prGroupType',
      col: 12,
    },
    {
      label: '计划名称',
      prop: 'prName',
      col: 24,
    },
    {
      label: '计划检验开始时间',
      prop: 'prBeginTime',
      col: 12,
    },
    {
      label: '计划检验结束时间',
      prop: 'prEndTime',
      col: 12,
    },
    {
      label: '备注信息',
      prop: 'prRemarks',
      col: 24,
    },
    {
      type: 'table',
      label: '计划明细',
      prop: '',
      tableHead: [
        {
          type: 'index',
          label: '#',
          prop: '',
        },
        {
          label: '工程名称',
          prop: '',
        },
        {
          label: '高温紧固件名称',
          prop: '',
        },
        {
          label: '高温紧固件编号',
          prop: '',
        },
        {
          label: '机组类别',
          prop: '',
        },
        {
          label: '检验类别',
          prop: '',
        },
        {
          label: '分部件名称',
          prop: '',
        },
        {
          label: '部件编号',
          prop: '',
        },
        {
          label: '检测数量',
          prop: '',
        },
        {
          type: 'operation',
          label: '操作',
          prop: '',
          operation: [
            {
              type: 'view',
              label: '查看',
              prop: '',
              formType: 'highTemperatureFastenersDetail',
            },
          ],
        },
      ],
    },
  ],
  highTemperatureFastenersDetail: [
    {
      label: '工程名称',
      prop: 'prProjectName',
      col: 12,
    },
    {
      label: '高温紧固件名称',
      prop: '',
      col: 12,
    },
    {
      label: '高温紧固件编号',
      prop: '',
      col: 12,
    },
    {
      label: '机组类别',
      prop: 'prGroupType',
      col: 12,
    },
    {
      label: '分部件名称',
      prop: 'prDivisionName',
      col: 12,
    },
    {
      label: '部件编号',
      prop: 'prDivisionNum',
      col: 12,
    },
    {
      label: '检验方法',
      prop: 'prInspectMethod',
      col: 12,
    },
    {
      label: '检测数量',
      prop: '',
      col: 12,
    },
    {
      label: '备注信息',
      prop: 'prRemarks',
      col: 24,
    },
  ],
  steamTurbine: [
    {
      label: '工程名称',
      prop: 'prProjectName',
      col: 12,
    },
    {
      label: '机组类别',
      prop: 'prGroupType',
      col: 12,
    },
    {
      label: '计划名称',
      prop: 'prName',
      col: 24,
    },
    {
      label: '计划检验开始时间',
      prop: 'prBeginTime',
      col: 12,
    },
    {
      label: '计划检验结束时间',
      prop: 'prEndTime',
      col: 12,
    },
    {
      label: '备注信息',
      prop: 'prRemarks',
      col: 24,
    },
    {
      type: 'table',
      label: '计划明细',
      prop: '',
      tableHead: [
        {
          type: 'index',
          label: '#',
          prop: '',
        },
        {
          label: '工程名称',
          prop: '',
        },
        {
          label: '汽轮机名称',
          prop: '',
        },
        {
          label: '汽轮机编号',
          prop: '',
        },
        {
          label: '机组类别',
          prop: '',
        },
        {
          label: '分部件名称',
          prop: '',
        },
        {
          label: '分部件编号',
          prop: '',
        },
        {
          label: '部件编号',
          prop: '',
        },
        {
          label: '检测数量',
          prop: '',
        },
        {
          type: 'operation',
          label: '操作',
          prop: '',
          operation: [
            {
              type: 'view',
              label: '查看',
              prop: '',
              formType: 'steamTurbineDetail',
            },
          ],
        },
      ],
    },
  ],
  steamTurbineDetail: [
    {
      label: '工程名称',
      prop: 'prProjectName',
      col: 12,
    },
    {
      label: '汽轮机名称',
      prop: '',
      col: 12,
    },
    {
      label: '汽轮机编号',
      prop: '',
      col: 12,
    },
    {
      label: '机组类别',
      prop: 'prGroupType',
      col: 12,
    },
    {
      label: '分部件编号',
      prop: '',
      col: 12,
    },
    {
      label: '部件编号',
      prop: 'prDivisionNum',
      col: 12,
    },
    {
      label: '材质',
      prop: '',
      col: 12,
    },
    {
      label: '规格',
      prop: '',
      col: 12,
    },
    {
      label: '最后委托检测完成时间',
      prop: '',
      col: 12,
    },
    {
      label: '备注信息',
      prop: 'prRemarks',
      col: 24,
    },
  ],
  gasEngine: [
    {
      label: '工程名称',
      prop: 'prProjectName',
      col: 12,
    },
    {
      label: '机组类别',
      prop: 'prGroupType',
      col: 12,
    },
    {
      label: '计划名称',
      prop: '',
      col: 24,
    },
    {
      label: '计划检验开始时间',
      prop: 'prBeginTime',
      col: 12,
    },
    {
      label: '计划检验结束时间',
      prop: 'prEndTime',
      col: 12,
    },
    {
      label: '备注信息',
      prop: 'prRemarks',
      col: 24,
    },
    {
      type: 'table',
      label: '计划明细',
      prop: '',
      tableHead: [
        {
          type: 'index',
          label: '#',
          prop: '',
        },
        {
          label: '工程名称',
          prop: '',
        },
        {
          label: '燃气机名称',
          prop: '',
        },
        {
          label: '燃气机编号',
          prop: '',
        },
        {
          label: '机组类别',
          prop: '',
        },
        {
          label: '分部件名称',
          prop: '',
        },
        {
          label: '分部件编号',
          prop: '',
        },
        {
          label: '部件编号',
          prop: '',
        },
        {
          label: '检测数量',
          prop: '',
        },
        {
          type: 'operation',
          label: '操作',
          prop: '',
          operation: [
            {
              type: 'view',
              label: '查看',
              prop: '',
              formType: 'gasEngineDetail',
            },
          ],
        },
      ],
    },
  ],
  gasEngineDetail: [
    {
      label: '工程名称',
      prop: 'prProjectName',
      col: 12,
    },
    {
      label: '燃气机名称',
      prop: '',
      col: 12,
    },
    {
      label: '燃气机编号',
      prop: '',
      col: 12,
    },
    {
      label: '部件类别',
      prop: '',
      col: 12,
    },
    {
      label: '分部件编号',
      prop: '',
      col: 12,
    },
    {
      label: '部件编号',
      prop: 'prDivisionNum',
      col: 12,
    },
    {
      label: '材质',
      prop: '',
      col: 12,
    },
    {
      label: '规格',
      prop: '',
      col: 12,
    },
    {
      label: '最后委托检测完成时间',
      prop: '',
      col: 12,
    },
    {
      label: '备注信息',
      prop: 'prRemarks',
      col: 24,
    },
  ],
  generator: [
    {
      label: '工程名称',
      prop: 'prProjectName',
      col: 12,
    },
    {
      label: '机组类别',
      prop: 'prGroupType',
      col: 12,
    },
    {
      label: '计划名称',
      prop: '',
      col: 24,
    },
    {
      label: '计划检验开始时间',
      prop: 'prBeginTime',
      col: 12,
    },
    {
      label: '计划检验结束时间',
      prop: 'prEndTime',
      col: 12,
    },
    {
      label: '备注信息',
      prop: 'prRemarks',
      col: 24,
    },
    {
      type: 'table',
      label: '计划明细',
      prop: '',
      tableHead: [
        {
          type: 'index',
          label: '#',
          prop: '',
        },
        {
          label: '工程名称',
          prop: '',
        },
        {
          label: '发电机名称',
          prop: '',
        },
        {
          label: '发电机编号',
          prop: '',
        },
        {
          label: '机组类别',
          prop: '',
        },
        {
          label: '分部件名称',
          prop: '',
        },
        {
          label: '分部件编号',
          prop: '',
        },
        {
          label: '部件编号',
          prop: '',
        },
        {
          label: '检测数量',
          prop: '',
        },
        {
          type: 'operation',
          label: '操作',
          prop: '',
          operation: [
            {
              type: 'view',
              label: '查看',
              prop: '',
              formType: 'generatorDetail',
            },
          ],
        },
      ],
    },
  ],
  generatorDetail: [
    {
      label: '工程名称',
      prop: '',
      col: 12,
    },
    {
      label: '发电机名称',
      prop: '',
      col: 12,
    },
    {
      label: '发电机编号',
      prop: '',
      col: 12,
    },
    {
      label: '部件类别',
      prop: '',
      col: 12,
    },
    {
      label: '分部件编号',
      prop: '',
      col: 12,
    },
    {
      label: '部件编号',
      prop: '',
      col: 12,
    },
    {
      label: '材质',
      prop: '',
      col: 12,
    },
    {
      label: '规格',
      prop: '',
      col: 12,
    },
    {
      label: '最后委托检测完成时间',
      prop: '',
      col: 12,
    },
    {
      label: '备注信息',
      prop: '',
      col: 24,
    },
  ],
  // 金属BIM
  // 管道一级台账
  pipelineLevelOne: [
    {
      type: 'dividingLine',
      prop: '基础信息',
    },
    {
      label: '工程名称',
      prop: 'prProjectName',
      col: 8,
    },
    {
      label: '部件/管线名称',
      prop: 'prBaseName',
      col: 8,
    },
    {
      label: '管道单线图编号',
      prop: 'prBaseCode',
      col: 8,
    },
    {
      label: '机组类别',
      prop: 'prGroupType',
      col: 8,
    },
    {
      label: '检验类别',
      prop: 'prTestType',
      col: 8,
    },
    {
      type: 'dividingLine',
      prop: '部件信息',
    },
    {
      label: '分部件名称',
      prop: 'prTwoName',
      col: 8,
    },
    {
      label: '部件编号',
      prop: 'prCode',
      col: 8,
    },
    {
      label: '材质',
      prop: 'prMaterial',
      col: 8,
    },
    {
      label: '规格',
      prop: 'prSpec1',
      col: 8,
    },
    {
      label: '设计温度(℃)',
      prop: 'prDesignTemperature',
      col: 8,
    },
    {
      label: '设计压力(MPa)',
      prop: 'prDesignPressure',
      col: 8,
    },
    {
      label: '焊口数量',
      prop: '',
      col: 8,
    },
    {
      label: '焊接工艺评定编号',
      prop: 'prWeldingProcedureQualificationCode',
      col: 8,
    },
    {
      label: '工程类别',
      prop: 'prProjectType',
      col: 8,
    },
    {
      label: '检验比例(%)',
      prop: 'prTestRatio',
      col: 8,
    },
    {
      type: 'dividingLine',
      prop: '焊接施工工艺',
    },
    {
      label: '坡口形式',
      prop: 'prGrooveType',
      col: 8,
    },
    {
      label: '焊接方法',
      prop: 'prWeldingMethod',
      col: 8,
    },
    {
      label: '焊丝牌号',
      prop: 'prWeldingWireGrade',
      col: 8,
    },
    {
      label: '焊条牌号',
      prop: 'prTypeOfElectrode',
      col: 8,
    },
    {
      label: '焊接工艺卡编号',
      prop: 'prWeldingProcessCard',
      col: 8,
    },
    {
      type: 'dividingLine',
      prop: '预热',
    },
    {
      label: '方法',
      prop: 'prPreheatMethod',
      col: 8,
    },
    {
      label: '温度(℃)',
      prop: 'prPreheatTemperature',
      col: 8,
    },
    {
      type: 'dividingLine',
      prop: '热处理施工工艺',
    },
    {
      label: '加热方法',
      prop: 'prHeatingMethod',
      col: 8,
    },
    {
      label: '热处理工艺编号',
      prop: 'prHeatTreatmentProcessCode',
      col: 8,
    },
    {
      label: '升降温速度(℃/h)',
      prop: 'prRampRate',
      col: 8,
    },
    {
      label: '加热温度(℃)',
      prop: 'prHeatingTemperature',
      col: 8,
    },
    {
      label: '恒温时间(h)',
      prop: 'prHoldingTime',
      col: 8,
    },
    {
      label: '备注信息',
      prop: 'prRemarks',
      col: 24,
    },
  ],
  // 管道二级台账
  pipelineLevelTwo: [
    {
      type: 'dividingLine',
      prop: '基础信息',
    },
    {
      label: '工程名称',
      prop: '',
      col: 8,
    },
    {
      label: '部件/管线名称',
      prop: '',
      col: 8,
    },
    {
      label: '管道单线图编号',
      prop: '',
      col: 8,
    },
    {
      label: '施工单位',
      prop: '',
      col: 8,
    },
    {
      label: '机组类别',
      prop: '',
      col: 8,
    },
    {
      label: '检验类别',
      prop: '',
      col: 8,
    },
    {
      prop: '部件信息',
      type: 'dividingLine',
    },
    {
      label: '分部件名称',
      prop: 'prName',
      col: 8,
    },
    {
      label: '分部件序号',
      prop: 'prSerialNumber',
      col: 8,
    },
    {
      label: '分部件编号',
      prop: 'prCode',
      col: 8,
    },
    {
      label: '材质',
      prop: 'prMaterial',
      col: 8,
    },
    {
      type: 'double',
      label: '规格(mm)',
      leftProp: 'prSpec1',
      rightProp: 'prSpec2',
      col: 8,
    },
    {
      label: '设计温度(℃)',
      prop: 'prDesignTemperature',
      col: 8,
    },
    {
      label: '设计压力(MPa)',
      prop: 'prDesignPressure',
      col: 8,
    },
    {
      label: '检验方法',
      prop: 'prTestMethod',
      col: 16,
    },
    {
      prop: '焊接施工工艺',
      type: 'dividingLine',
    },
    {
      label: '坡口形式',
      prop: 'prGrooveType',
      col: 8,
    },
    {
      label: '焊接方法',
      prop: 'prWeldingMethod',
      col: 8,
    },
    {
      label: '焊丝牌号',
      prop: 'prWeldingWireGrade',
      col: 8,
    },
    {
      label: '焊条牌号',
      prop: 'prTypeOfElectrode',
      col: 8,
    },
    {
      label: '焊接工艺卡编号',
      prop: 'prWeldingProcessCard',
      col: 8,
    },
    {
      label: '焊工代号',
      prop: 'prWelderCode',
      col: 8,
    },
    {
      label: '焊接完成时间',
      prop: 'prWeldingCompletionTime',
      col: 8,
    },
    {
      prop: '热处理施工工艺',
      type: 'dividingLine',
    },
    {
      label: '是否热处理',
      prop: 'prIsHeatTreated',
      col: 8,
    },
    {
      label: '热处理工艺编号',
      prop: 'prHeatTreatmentProcessCode',
      col: 8,
    },
    {
      label: '热处理完成时间',
      prop: 'prHeatTreatmentCompletionTime',
      col: 8,
    },
    {
      prop: '其他信息',
      type: 'dividingLine',
    },
    {
      label: '委托检测完成时间',
      prop: 'prEntrustedTestCompletionTime',
      col: 8,
    },
    {
      label: '计划检测完成时间',
      prop: 'prPlanTestCompletionTime',
      col: 8,
    },
    {
      label: '备注信息',
      prop: 'prRemarks',
      col: 24,
    },
  ],
  // 压力管道
  pressurePiping: [
    {
      label: '管道名称',
      prop: '',
      col: 12,
    },
    {
      label: '管道编号',
      prop: '',
      col: 12,
    },
    {
      label: '安装起点',
      prop: '',
      col: 12,
    },
    {
      label: '安装终点',
      prop: '',
      col: 12,
    },
    {
      label: '设计单位',
      prop: '',
      col: 12,
    },
    {
      label: '安装单位',
      prop: '',
      col: 12,
    },
    {
      type: 'attachment',
      label: '安装监督检验检查文件资料包附件',
      prop: '',
      col: 24,
    },
    {
      label: '设备投用时间',
      prop: '',
      col: 12,
    },
    {
      label: '设计压力(MPa)',
      prop: '',
      col: 12,
    },
    {
      label: '设计温度(℃)',
      prop: '',
      col: 12,
    },
    {
      label: '最高工作压力(MPa)',
      prop: '',
      col: 12,
    },
    {
      label: '最高工作温度(℃)',
      prop: '',
      col: 12,
    },
    {
      label: '介质种类',
      prop: '',
      col: 12,
    },
    {
      label: '公称直径(mm)',
      prop: '',
      col: 12,
    },
    {
      label: '公称壁厚(mm)',
      prop: '',
      col: 12,
    },
    {
      label: '材质',
      prop: '',
      col: 12,
    },
    {
      label: '管道长度(m)',
      prop: '',
      col: 12,
    },
    {
      label: '设备编号',
      prop: '',
      col: 12,
    },
    {
      label: '设备代码',
      prop: '',
      col: 12,
    },
    {
      label: '设备类型',
      prop: '',
      col: 12,
    },
    {
      label: '管道单线图编号',
      prop: '',
      col: 12,
    },
    {
      type: 'attachment',
      label: '管道单线图附件',
      prop: '',
      col: 24,
    },
    {
      type: 'attachment',
      label: '注册资料附件',
      prop: '',
      col: 24,
    },
    {
      type: 'attachment',
      label: '注册使用登记证附件',
      prop: '',
      col: 24,
    },
    {
      label: '使用登记证发放日期',
      prop: '',
      col: 12,
    },
    {
      label: '使用登记证编号',
      prop: '',
      col: 12,
    },
    {
      label: '全面检验日期',
      prop: '',
      col: 12,
    },
    {
      label: '全面检验到期日',
      prop: '',
      col: 12,
    },
    {
      type: 'attachment',
      label: '全面检验报告',
      prop: '',
      col: 24,
    },
    {
      label: '全面检验报告',
      prop: '',
      col: 12,
    },
    {
      label: '在线检验日期',
      prop: '',
      col: 12,
    },
    {
      label: '在线检验到期日',
      prop: '',
      col: 12,
    },
    {
      type: 'attachment',
      label: '在线检验报告',
      prop: '',
      col: 24,
    },
  ],
  // 压力容器
  pressureVessels: [
    {
      label: '设备名称',
      prop: '',
      col: 12,
    },
    {
      label: '厂内设备编号',
      prop: '',
      col: 12,
    },
    {
      label: '专业',
      prop: '',
      col: 12,
    },
    {
      label: '制造单位',
      prop: '',
      col: 12,
    },
    {
      label: '容器制造日期',
      prop: '',
      col: 12,
    },
    {
      label: '压力容器类别',
      prop: '',
      col: 12,
    },
    {
      label: '产品编号',
      prop: '',
      col: 12,
    },
    {
      type: 'attachment',
      label: '设备出厂附件',
      prop: '',
      col: 24,
    },
    {
      label: '设计压力(Mpa)',
      prop: '',
      col: 12,
    },
    {
      label: '设计温度(℃)',
      prop: '',
      col: 12,
    },
    {
      label: '最高运行温度(℃)',
      prop: '',
      col: 12,
    },
    {
      label: '最高运行压力(Mpa)',
      prop: '',
      col: 12,
    },
    {
      label: '介质',
      prop: '',
      col: 12,
    },
    {
      label: '规格(ψ*h*w)mm',
      prop: '',
      col: 12,
    },
    {
      label: '容积(m³)',
      prop: '',
      col: 12,
    },
    {
      label: '材质',
      prop: '',
      col: 12,
    },
    {
      label: '设备编号',
      prop: '',
      col: 12,
    },
    {
      label: '设备代码',
      prop: '',
      col: 12,
    },
    {
      type: 'attachment',
      label: '压力容器注册资料',
      prop: '',
      col: 24,
    },
    {
      label: '注册登记证发放日期',
      prop: '',
      col: 12,
    },
    {
      label: '注册登记证编号',
      prop: '',
      col: 12,
    },
    {
      type: 'attachment',
      label: '注册使用登记证附件',
      prop: '',
      col: 24,
    },
    {
      label: '年度检查日期',
      prop: '',
      col: 12,
    },
    {
      label: '年度检验到期日',
      prop: '',
      col: 12,
    },
    {
      type: 'attachment',
      label: '年度检验报告',
      prop: '',
      col: 24,
    },
    {
      label: '定期检验日期',
      prop: '',
      col: 12,
    },
    {
      label: '定期检验到期日',
      prop: '',
      col: 12,
    },
    {
      type: 'attachment',
      label: '定期检验报告',
      prop: '',
      col: 24,
    },
    {
      label: '安装位置',
      prop: '',
      col: 12,
    },
    {
      label: '安装单位',
      prop: '',
      col: 12,
    },
    {
      label: '设备投用时间',
      prop: '',
      col: 12,
    },
  ],
  // 简单压力容器
  simplePressureVessels: [
    {
      label: '设备名称',
      prop: '',
      col: 12,
    },
    {
      label: '厂内设备编号',
      prop: '',
      col: 12,
    },
    {
      label: '专业',
      prop: '',
      col: 12,
    },
    {
      label: '安装位置',
      prop: '',
      col: 12,
    },
    {
      label: '推荐使用寿命',
      prop: '',
      col: 12,
    },
    {
      label: '设备使用到期日',
      prop: '',
      col: 12,
    },
    {
      label: '制造单位',
      prop: '',
      col: 12,
    },
    {
      label: '容器制造日期',
      prop: '',
      col: 12,
    },
    {
      label: '产品编号',
      prop: '',
      col: 12,
    },
    {
      type: 'attachment',
      label: '出厂设备资料',
      prop: '',
      col: 24,
    },
    {
      label: '设计温度(℃)',
      prop: '',
      col: 12,
    },
    {
      label: '设计压力(Mpa)',
      prop: '',
      col: 12,
    },
    {
      label: '容积(m³)',
      prop: '',
      col: 12,
    },
    {
      label: '工作介质',
      prop: '',
      col: 12,
    },
    {
      label: '定期检验日期',
      prop: '',
      col: 12,
    },
    {
      label: '定期检验到期日',
      prop: '',
      col: 12,
    },
    {
      type: 'attachment',
      label: '定期检验报告',
      prop: '',
      col: 24,
    },
  ],
  // 压力气瓶
  pressureCylinders: [
    {
      label: '设备名称',
      prop: '',
      col: 12,
    },
    {
      label: '存放位置',
      prop: '',
      col: 12,
    },
    {
      label: '专业',
      prop: '',
      col: 12,
    },
    {
      label: '制造单位',
      prop: '',
      col: 12,
    },
    {
      label: '钢瓶编号',
      prop: '',
      col: 12,
    },
    {
      type: 'attachment',
      label: '设备出厂附件',
      prop: '',
      col: 24,
    },
    {
      label: '制造日期',
      prop: '',
      col: 12,
    },
    {
      label: '公称压力(Mpa)',
      prop: '',
      col: 12,
    },
    {
      label: '有效容积(m³)',
      prop: '',
      col: 12,
    },
    {
      label: '充装介质',
      prop: '',
      col: 12,
    },
    {
      label: '设备编号',
      prop: '',
      col: 12,
    },
    {
      label: '设备代码',
      prop: '',
      col: 12,
    },
    {
      type: 'attachment',
      label: '压力气瓶注册资料附件',
      prop: '',
      col: 24,
    },
    {
      label: '注册登记证发放日期',
      prop: '',
      col: 12,
    },
    {
      label: '注册登记证编号',
      prop: '',
      col: 12,
    },
    {
      type: 'attachment',
      label: '注册使用登记证附件',
      prop: '',
      col: 24,
    },
    {
      label: '定期检验日期',
      prop: '',
      col: 12,
    },
    {
      label: '定期检验到期日',
      prop: '',
      col: 12,
    },
    {
      type: 'attachment',
      label: '定期检验报告',
      prop: '',
      col: 24,
    },
  ],
  // 锅炉设备
  boilerEquipment: [
    {
      label: '设备名称',
      prop: '',
      col: 12,
    },
    {
      label: '厂内设备编号',
      prop: '',
      col: 12,
    },
    {
      label: '锅炉设备单位',
      prop: '',
      col: 12,
    },
    {
      label: '锅炉型号',
      prop: '',
      col: 12,
    },
    {
      label: '产品编号',
      prop: '',
      col: 12,
    },
    {
      label: '锅炉制造日期',
      prop: '',
      col: 12,
    },
    {
      type: 'attachment',
      label: '压力气瓶注册资料附件',
      prop: '',
      col: 24,
    },
    {
      label: '安装单位',
      prop: '',
      col: 12,
    },
    {
      label: '设备投用时间',
      prop: '',
      col: 12,
    },
    {
      type: 'attachment',
      label: '安装监督检验检查文件资料包',
      prop: '',
      col: 24,
    },
    {
      label: '设计压力(Mpa)',
      prop: '',
      col: 12,
    },
    {
      label: '设计温度(Mpa)',
      prop: '',
      col: 12,
    },
    {
      label: '最高运行温度(Mpa)',
      prop: '',
      col: 12,
    },
    {
      label: '最高运行压力(Mpa)',
      prop: '',
      col: 12,
    },
    {
      label: '介质种类',
      prop: '',
      col: 12,
    },
    {
      label: '设备编号',
      prop: '',
      col: 12,
    },
    {
      label: '设备代码',
      prop: '',
      col: 12,
    },
    {
      type: 'attachment',
      label: '锅炉注册资料附件',
      prop: '',
      col: 24,
    },
    {
      label: '注册登记证发放日期',
      prop: '',
      col: 12,
    },
    {
      label: '注册登记证编号',
      prop: '',
      col: 12,
    },
    {
      type: 'attachment',
      label: '注册使用登记证附件',
      prop: '',
      col: 24,
    },
    {
      label: '锅炉外检日期',
      prop: '',
      col: 12,
    },
    {
      label: '锅炉外检到期日',
      prop: '',
      col: 12,
    },
    {
      type: 'attachment',
      label: '锅炉外检报告',
      prop: '',
      col: 24,
    },
  ],
  // 安全阀
  reliefValve: [
    {
      type: 'dividingLine',
      prop: '基础信息',
    },
    {
      label: '工程名称',
      prop: '',
      col: 8,
    },
    {
      label: '项次',
      prop: '',
      col: 8,
    },
    {
      label: '专业',
      prop: '',
      col: 8,
    },
    {
      label: '区域',
      prop: '',
      col: 8,
    },
    {
      label: '设备编号',
      prop: '',
      col: 8,
    },
    {
      label: '安全阀类型',
      prop: '',
      col: 8,
    },
    {
      label: '安全阀型号',
      prop: '',
      col: 8,
    },
    {
      label: '安全阀形式',
      prop: '',
      col: 8,
    },
    {
      label: '安全阀名称',
      prop: '',
      col: 8,
    },
    {
      label: '安装位置',
      prop: '',
      col: 8,
    },
    {
      label: '工作压力',
      prop: '',
      col: 8,
    },
    {
      label: '设计压力',
      prop: '',
      col: 8,
    },
    {
      label: '要求整顿压力MPA(G)',
      prop: '',
      col: 8,
    },
    {
      label: '工作介质',
      prop: '',
      col: 8,
    },
    {
      label: '介质温度',
      prop: '',
      col: 8,
    },
    {
      label: '阀杆时候外露',
      prop: '',
      col: 8,
    },
    {
      label: '制造单位',
      prop: '',
      col: 8,
    },
    {
      type: 'dividingLine',
      prop: '入口形式及尺寸',
    },
    {
      label: '型式',
      prop: '',
      col: 8,
    },
    {
      label: '公称通径',
      prop: '',
      col: 8,
    },
    {
      label: '公称压力',
      prop: '',
      col: 8,
    },
    {
      type: 'dividingLine',
      prop: '安全阀检验信息',
    },
    {
      label: '检验委托日期',
      prop: '',
      col: 8,
    },
    {
      label: '委托单编号',
      prop: '',
      col: 8,
    },
    {
      label: '校验方式',
      prop: '',
      col: 8,
    },
    {
      label: '校验日期',
      prop: '',
      col: 8,
    },
    {
      label: '校验到期日期',
      prop: '',
      col: 8,
    },
    {
      type: 'attachment',
      label: '安全阀校验报告',
      prop: '',
      col: 24,
    },
    {
      label: '备注',
      prop: '',
      col: 24,
    },
  ],
  // 支吊架
  supportHanger: [
    {
      label: '机组',
      prop: '',
      col: 12,
    },
    {
      label: '管线支吊架名称',
      prop: '',
      col: 12,
    },
    {
      label: '支吊架图纸编号',
      prop: '',
      col: 12,
    },
    {
      label: '专业',
      prop: '',
      col: 12,
    },
    {
      type: 'attachment',
      label: '支吊架图纸台账',
      prop: '',
      col: 12,
    },
    {
      type: 'attachment',
      label: '安装单位',
      prop: '',
      col: 12,
    },
    {
      label: '安装时间',
      prop: '',
      col: 12,
    },
    {
      label: '冷态检查时间',
      prop: '',
      col: 12,
    },
    {
      label: '热态检查时间',
      prop: '',
      col: 12,
    },
    {
      label: '年度检查到期日',
      prop: '',
      col: 12,
    },
    {
      label: '全面检查时间',
      prop: '',
      col: 12,
    },
    {
      label: '全面检查到期日期',
      prop: '',
      col: 12,
    },
    {
      type: 'table',
      label: '支吊架报告/方案清单',
      prop: '',
      tableHead: [
        {
          label: '检查类型',
          prop: '',
        },
        {
          label: '检查报告/方案名称',
          prop: '',
        },
        {
          label: '检查时间',
          prop: '',
        },
        {
          label: '检查单位',
          prop: '',
        },
      ],
    },
  ],
  // 支吊架详情
  supportHangerDetail: [
    {
      type: 'dividingLine',
      prop: '检验人员证书表',
    },
    {
      label: '检查类型',
      prop: '',
      col: 12,
    },
    {
      label: '检查报告/方案名称',
      prop: '',
      col: 12,
    },
    {
      label: '检查时间',
      prop: '',
      col: 12,
    },
    {
      label: '检查单位',
      prop: '',
      col: 12,
    },
    {
      type: 'attachment',
      label: '冷态检查报告',
      prop: '',
      col: 24,
    },
    {
      type: 'attachment',
      label: '热态检查报告',
      prop: '',
      col: 24,
    },
    {
      type: 'attachment',
      label: '全面检查及调整方案',
      prop: '',
      col: 24,
    },
    {
      type: 'attachment',
      label: '全面检查报告',
      prop: '',
      col: 24,
    },
    {
      label: '检查单位',
      prop: '',
      col: 24,
    },
  ],
  // 支吊架异常管控台账
  supportHangerAbnormal: [
    {
      label: '机组',
      prop: '',
      col: 12,
    },
    {
      label: '专业',
      prop: '',
      col: 12,
    },
    {
      label: '系统类别',
      prop: '',
      col: 12,
    },
    {
      label: '支吊架编号',
      prop: '',
      col: 12,
    },
    {
      label: '支吊架类型',
      prop: '',
      col: 12,
    },
    {
      label: '异常类型',
      prop: '',
      col: 12,
    },
    {
      label: '严重程度',
      prop: '',
      col: 12,
    },
    {
      label: '发现时间',
      prop: '',
      col: 12,
    },
    {
      label: '异常情况说明',
      prop: '',
      col: 24,
    },
    {
      label: '异常原因',
      prop: '',
      col: 24,
    },
    {
      label: '处理对策',
      prop: '',
      col: 24,
    },
    {
      type: 'image',
      label: '异常图片',
      prop: '',
    },
    {
      label: '预计处理完成时间',
      prop: '',
      col: 12,
    },
    {
      label: '备注',
      prop: '',
      col: 12,
    },
  ],
  // 锅炉集箱
  boilerContainers: [
    {
      label: '机组类别',
      prop: '',
      col: 12,
    },
    {
      label: '集箱名称',
      prop: '',
      col: 12,
    },
    {
      label: '集箱编号',
      prop: '',
      col: 12,
    },
    {
      type: 'attachment',
      label: '集箱图纸',
      prop: '',
      col: 24,
    },
    {
      label: '分部件名称',
      prop: '',
      col: 12,
    },
    {
      label: '分部件序号',
      prop: '',
      col: 12,
    },
    {
      label: '部件编号',
      prop: '',
      col: 12,
    },
    {
      label: '检验类别',
      prop: '',
      col: 12,
    },
    {
      label: '材质',
      prop: '',
      col: 12,
    },
    {
      label: '规格',
      prop: '',
      col: 12,
    },
    {
      label: '温度(℃)',
      prop: '',
      col: 12,
    },
    {
      label: '压力(MPa)',
      prop: '',
      col: 12,
    },
    {
      label: '检验方法',
      prop: '',
      col: 12,
    },
    {
      label: '最后委托完成时间',
      prop: '',
      col: 12,
    },
    {
      label: '备注信息',
      prop: '',
      col: 24,
    },
  ],
  // 锅炉受热面
  boilerHeatingSurface: [
    {
      label: '机组类别',
      prop: '',
      col: 12,
    },
    {
      label: '锅炉受热面名称',
      prop: '',
      col: 12,
    },
    {
      label: '锅炉受热面编号',
      prop: '',
      col: 12,
    },
    {
      type: 'attachment',
      label: '锅炉受热面图纸',
      prop: '',
      col: 24,
    },
    {
      label: '分部件名称',
      prop: '',
      col: 12,
    },
    {
      label: '分部件序号',
      prop: '',
      col: 12,
    },
    {
      label: '部件编号',
      prop: '',
      col: 12,
    },
    {
      label: '检验类别',
      prop: '',
      col: 12,
    },
    {
      label: '材质',
      prop: '',
      col: 12,
    },
    {
      label: '规格(mm)',
      prop: '',
      col: 12,
    },
    {
      label: '温度(℃)',
      prop: '',
      col: 12,
    },
    {
      label: '压力(MPa)',
      prop: '',
      col: 12,
    },
    {
      label: '检验方法',
      prop: '',
      col: 12,
    },
    {
      label: '记录最新委托检测完成时间',
      prop: '',
      col: 12,
    },
    {
      label: '备注信息',
      prop: '',
      col: 24,
    },
  ],
  // 大型铸件一级台账
  largeCastingsLevelOne: [
    {
      label: '机组类别',
      prop: '',
      col: 12,
    },
    {
      label: '大型铸件名称',
      prop: '',
      col: 12,
    },
    {
      label: '大型铸件编号',
      prop: '',
      col: 12,
    },
    {
      label: '部件类别',
      prop: '',
      col: 12,
    },
    {
      label: '部件编号',
      prop: '',
      col: 12,
    },
    {
      label: '材质',
      prop: '',
      col: 12,
    },
    {
      label: '厚度(mm)',
      prop: '',
      col: 12,
    },
    {
      label: '温度(℃)',
      prop: '',
      col: 12,
    },
    {
      label: '压力(MPa)',
      prop: '',
      col: 12,
    },
    {
      label: '数量',
      prop: '',
      col: 12,
    },
    {
      label: '检验比例',
      prop: '',
      col: 12,
    },
  ],
  // 大型铸件二级台账
  largeCastingsLevelTwo: [
    {
      label: '机组类别',
      prop: '',
      col: 12,
    },
    {
      label: '大型铸件名称',
      prop: '',
      col: 12,
    },
    {
      label: '大型铸件编号',
      prop: '',
      col: 12,
    },
    {
      type: 'attachment',
      label: '大型铸件图纸',
      prop: '',
      col: 24,
    },
    {
      label: '部件类别',
      prop: '',
      col: 12,
    },
    {
      label: '部件编号',
      prop: '',
      col: 12,
    },
    {
      label: '材质',
      prop: '',
      col: 12,
    },
    {
      label: '厚度(mm)',
      prop: '',
      col: 12,
    },
    {
      label: '温度(℃)',
      prop: '',
      col: 12,
    },
    {
      label: '压力(MPa)',
      prop: '',
      col: 12,
    },
    {
      label: '检验方法',
      prop: '',
      col: 12,
    },
    {
      label: '最后委托检测完成时间',
      prop: '',
      col: 12,
    },
    {
      label: '备注信息',
      prop: '',
      col: 24,
    },
  ],
  // 高温紧固件
  highTemperatureFastener: [
    {
      label: '机组类别',
      prop: '',
      col: 12,
    },
    {
      label: '高温紧固件名称',
      prop: '',
      col: 12,
    },
    {
      type: 'attachment',
      label: '高温紧固件图纸',
      prop: '',
      col: 24,
    },
    {
      label: '分部件名称',
      prop: '',
      col: 12,
    },
    {
      label: '分部件序号',
      prop: '',
      col: 12,
    },
    {
      label: '部件编号',
      prop: '',
      col: 12,
    },
    {
      label: '检验类别',
      prop: '',
      col: 12,
    },
    {
      label: '材质',
      prop: '',
      col: 12,
    },
    {
      label: '规格(mm)',
      prop: '',
      col: 12,
    },
    {
      label: '温度(℃)',
      prop: '',
      col: 12,
    },
    {
      label: '检验方法',
      prop: '',
      col: 12,
    },
    {
      label: '记录最新委托检测完成时间',
      prop: '',
      col: 12,
    },
    {
      label: '备注信息',
      prop: '',
      col: 24,
    },
  ],
  // 汽轮机固件
  steamTurbineFirmware: [
    {
      label: '部件类别',
      prop: '',
      col: 12,
    },
    {
      label: '汽轮机',
      prop: '',
      col: 12,
    },
    {
      label: '汽轮机编号',
      prop: '',
      col: 12,
    },
    {
      label: '机组类别',
      prop: '',
      col: 12,
    },
    {
      label: '分部件编号',
      prop: '',
      col: 12,
    },
    {
      label: '材质',
      prop: '',
      col: 12,
    },
    {
      label: '规格',
      prop: '',
      col: 12,
    },
    {
      label: '工作温度(℃)',
      prop: '',
      col: 12,
    },
    {
      label: '检验方法',
      prop: '',
      col: 12,
    },
    {
      label: '最后委托检测完成时间',
      prop: '',
      col: 12,
    },
    {
      label: '备注',
      prop: '',
      col: 24,
    },
  ],
  // 燃气机部件
  gasEngineParts: [
    {
      label: '部件类别',
      prop: '',
      col: 12,
    },
    {
      label: '燃气机',
      prop: '',
      col: 12,
    },
    {
      label: '汽轮机编号',
      prop: '',
      col: 12,
    },
    {
      label: '机组类别',
      prop: '',
      col: 12,
    },
    {
      label: '分部件编号',
      prop: '',
      col: 12,
    },
    {
      label: '分部件序号',
      prop: '',
      col: 12,
    },
    {
      label: '部件编号',
      prop: '',
      col: 12,
    },
    {
      label: '材质',
      prop: '',
      col: 12,
    },
    {
      label: '规格',
      prop: '',
      col: 12,
    },
    {
      label: '工作温度(℃)',
      prop: '',
      col: 12,
    },
    {
      label: '检验方法',
      prop: '',
      col: 12,
    },
    {
      label: '最后委托检测完成时间',
      prop: '',
      col: 12,
    },
    {
      label: '备注',
      prop: '',
      col: 24,
    },
  ],
  // 发电机部件
  generatorParts: [
    {
      label: '部件类别',
      prop: '',
      col: 12,
    },
    {
      label: '燃气机',
      prop: '',
      col: 12,
    },
    {
      label: '汽轮机编号',
      prop: '',
      col: 12,
    },
    {
      label: '机组类别',
      prop: '',
      col: 12,
    },
    {
      label: '分部件编号',
      prop: '',
      col: 12,
    },
    {
      label: '分部件序号',
      prop: '',
      col: 12,
    },
    {
      label: '部件编号',
      prop: '',
      col: 12,
    },
    {
      label: '材质',
      prop: '',
      col: 12,
    },
    {
      label: '规格',
      prop: '',
      col: 12,
    },
    {
      label: '工作温度(℃)',
      prop: '',
      col: 12,
    },
    {
      label: '检验方法',
      prop: '',
      col: 12,
    },
    {
      label: '最后委托检测完成时间',
      prop: '',
      col: 12,
    },
    {
      label: '备注',
      prop: '',
      col: 24,
    },
  ],
}

/**
 * @description 金属BIM 下拉框options
 */
export const metalBimOptions = [
  { label: '管道基础台账', value: 'pipelineFoundationLedger' },
  { label: '压力管道', value: 'pressurePiping' },
  { label: '压力容器', value: 'pressureVessels' },
  { label: '简单压力容器', value: 'simplePressureVessels' },
  { label: '压力气瓶', value: 'pressureCylinders' },
  { label: '锅炉', value: 'boiler' },
  { label: '安全阀', value: 'reliefValve' },
]
/**
 * @description 金属BIM 动态表格-表头
 * @param {Array} tableHead
 * @param {string} api
 */
export const metalTableConfig = {
  pipelineFoundationLedger: {
    tableHead: [
      { label: '机组', prop: 'prGroupType', width: 50 },
      { label: '管道单线图编号', prop: 'prCode', width: 90 },
      { label: '部件/管线名称', prop: 'prName', type: 'ThreeDimensional', with: 100 },
    ],
    api: 'getPipelineLedgerBase',
    child: {
      code: 'MetalBimChild',
      name: '管道二级台账',
    },
  },
  pressurePiping: {
    tableHead: [
      { label: '管道编号', prop: 'prPipelineNum', width: 120 },
      { label: '管道名称', prop: 'prPipelineName', width: 120, type: 'ThreeDimensional' },
    ],
    api: 'getSpecialPressurePipeline',
  },
  pressureVessels: {
    tableHead: [
      { label: '厂内设备编号', prop: 'prContainerNum', width: 85 },
      { label: '设备名称', prop: 'prContainerName', width: 80, type: 'ThreeDimensional' },
      { label: '专业', prop: 'prProfessional', width: 85 },
    ],
    api: 'getSpecialPressureContainer',
  },
  simplePressureVessels: {
    tableHead: [
      { label: '厂内设备编号', prop: 'prContainerNum', width: 80 },
      { label: '设备名称', prop: 'prContainerName', width: 80, type: 'ThreeDimensional' },
      { label: '专业', prop: 'prProfessional', width: 85 },
    ],
    api: 'getSpecialSimplePressureContainer',
  },
  pressureCylinders: {
    tableHead: [
      { label: '钢瓶编号', prop: 'prEqNum', width: 65 },
      { label: '设备名称', prop: 'prCylinderName', type: 'ThreeDimensional', width: 65 },
      { label: '存放位置', prop: 'prEqInstallLocation', width: 70 },
      { label: '专业', prop: 'prProfessional', width: 50 },
    ],
    api: 'getSpecialPressureCylinder',
  },
  boiler: {
    tableHead: [
      { label: '厂内设备编号', prop: 'prBoilerNum', width: 110 },
      { label: '设备名称', prop: 'prBoilerName', width: 110, type: 'ThreeDimensional' },
    ],
    api: 'getSpecialPressureBoiler',
  },
  reliefValve: {
    tableHead: [
      { label: '设备编号', prop: 'prEqNum', width: 90 },
      { label: '安全阀名称', prop: 'prReliefValveName', width: 100, type: 'ThreeDimensional' },
      { label: '专业', prop: 'prProfessional', width: 50 },
    ],
    api: 'getJsRelifeValue',
  },
}
/**
 * @description 金属BIM childe
 * @param {Array} tableHead
 * @param {string} api
 */
export const metalBimChildConfig = {
  pipelineSecondaryLedger: {
    tableHead: [
      { label: '机组', prop: 'PrGroupType', width: 50 }, // 父组件赋值
      { label: '部件/管线名称', prop: 'PrName', width: 80 }, // 父组件赋值
      { label: '分部件编码', prop: 'prCode', width: 65 },
      { label: '部件名称', prop: 'prName', width: 55, type: 'ThreeDimensional' },
    ],
    api: 'getPipelineLedgerTwo',
  },
}
/**
 * @description 金属BIM detail
 */
export const metalBimDetailConfig = {
  pipelineFoundationLedger: [
    { label: '施工单位', prop: 'prBuildUnitName', col: 24 },
    { label: '管道单线图编号', prop: 'prCode', col: 12 },
    { label: '部件/管线名称', prop: 'prName', col: 12 },
    { label: '工程名称', prop: 'prProjectName', col: 12 },
    { label: '机组类别', prop: 'prGroupType', col: 12 },
    { label: '检验类别', prop: 'prTestType', col: 12 },
    { label: '备注信息', prop: 'prRemarks', col: 24 },
    { label: '单线图附件', prop: 'prSingleLineDiagramFile', col: 24, type: 'attachment' },
    { label: 'CAD附件', prop: 'prCadFile', col: 24, type: 'attachment' },
  ],
  pipelineSecondaryLedger: [
    { type: 'dividingLine', prop: '基础信息' },
    { label: '施工单位', prop: 'prBuildUnitName', col: 14 },
    { label: '机组类别', prop: 'prGroupType', col: 10 },
    { label: '部件/管线名称', prop: 'fatherPrName', col: 14 }, // 父级传递
    { label: '检验类别', prop: 'prTestType', col: 10 },
    { label: '工程名称', prop: 'prProjectName', col: 14 },
    { label: '管道单线图编号', prop: 'fatherPrCode', col: 10 }, // 父级传递
    { type: 'dividingLine', prop: '部件信息' },
    { label: '分部件名称', prop: 'prName', col: 12 },
    { label: '分部件序号', prop: 'prSerialNumber', col: 12 },
    { label: '分部件编码', prop: 'prCode', col: 12 },
    { label: '材质', prop: 'prMaterial', col: 12 },
    { label: '规格（mm）', leftProp: 'prSpec1', rightProp: 'prSpec2', col: 12, type: 'double' },
    { label: '设计温度（℃）', prop: 'prDesignTemperature', col: 12 },
    { label: '设计压力（MPa）', prop: 'prDesignPressure', col: 12 },
    { label: '检验方法', prop: 'prTestMethod', col: 12 },
    { type: 'dividingLine', prop: '焊接施工工艺' },
    { label: '坡口形式', prop: 'prGrooveType', col: 12 },
    { label: '焊接方法', prop: 'prWeldingMethod', col: 12 },
    { label: '焊丝牌号', prop: 'prWeldingWireGrade', col: 12 },
    { label: '焊条牌号', prop: 'prTypeOfElectrode', col: 12 },
    { label: '焊接工艺卡编号', prop: 'prWeldingProcessCard', col: 12 },
    { label: '焊工代号', prop: 'prWelderCode', col: 12 },
    { label: '焊接完成时间', prop: 'prWeldingCompletionTime', col: 24 },
    { type: 'dividingLine', prop: '热处理施工工艺' },
    { label: '是否热处理', prop: 'prIsHeatTreated', col: 12 },
    { label: '热处理工艺编号', prop: 'prHeatTreatmentProcessCode', col: 12 },
    { label: '热处理完成时间', prop: 'prHeatTreatmentCompletionTime', col: 12 },
    { type: 'dividingLine', prop: '其他信息' },
    { label: '委托检测完成时间', prop: 'prEntrustedTestCompletionTime', col: 12 },
    { label: '计划检测完成时间', prop: 'prPlanTestCompletionTime', col: 12 },
    { label: '备注信息', prop: 'prRemarks', col: 24 },
  ],
  pressurePiping: [
    { label: '管道名称', prop: 'prPipelineName', col: 12 },
    { label: '管道编号', prop: 'prPipelineNum', col: 12 },
    { label: '安装起点', prop: 'prEqInstallStart', col: 12 },
    { label: '安装终点', prop: 'prEqInstallEnd', col: 12 },
    { label: '设计单位', prop: 'prEqDesiUnit', col: 12 },
    { label: '安装单位', prop: 'prEqInstallUnit', col: 12 },
    {
      label: '安装监督检验检查文件资料包附件',
      prop: 'prEqInstallFile',
      col: 24,
      type: 'attachment',
      labelWidth: 230,
    },
    { label: '设备投用时间', prop: 'prEqInstallProductionTime', col: 12 },
    { label: '设计压力（Mpa）', prop: 'prEqDesiPressure', col: 12 },
    { label: '设计温度（℃）', prop: 'prEqDesiTemperature', col: 12 },
    { label: '最高工作压力（Mpa）', prop: 'prEqWorkingMaxPressure', col: 12 },
    { label: '最高工作温度（℃）', prop: 'prEqWorkingMaxTemperature', col: 12 },
    { label: '介质种类', prop: 'prEqWorkingMediaType', col: 12 },
    { label: '公称直径（mm）', prop: 'prEqSpecificationsDiameter', col: 12 },
    { label: '公称壁厚（mm）', prop: '', col: 12 },
    { label: '材质', prop: 'prEqSpecificationsThickness', col: 12 },
    { label: '管道长度（m）', prop: '', col: 12 },
    { label: '设备编号', prop: 'prEqSpecificationsWidth', col: 12 },
    { label: '设备代码', prop: 'prEqCode', col: 12 },
    { label: '管道类型', prop: 'prPipelineType', col: 12 },
    { label: '管道单线图编号', prop: 'prSingleLineDiagramNum', col: 12 },
    { label: '管道单线图附件', prop: 'prSingleLineDiagramFile', col: 24, type: 'attachment' },
    { label: '注册资料附件', prop: 'prRegistInfo', col: 24, type: 'attachment' },
    { label: '注册使用登记证附件', prop: 'prRegistCertificateFile', col: 24, type: 'attachment' },
    { label: '使用登记证发放日期', prop: 'prRegistCertificateDate', col: 12 },
    { label: '使用登记证编号', prop: '使用登记证编号', col: 12 },
    { label: '全面检验日期', prop: 'prAllInspectDate', col: 12 },
    { label: '全面检验到期日', prop: 'prAllInspectDueDate', col: 12 },
    { label: '全面检验报告', prop: 'prAllInspectReport', col: 24, type: 'attachment' },
    { label: '在线检验日期', prop: 'prOnlineInspectDate', col: 12 },
    { label: '在线检验到期日', prop: 'prOnlineInspectDueDate', col: 12 },
    { label: '在线检验报告', prop: 'prOnlineInspectReport', col: 24, type: 'attachment' },
  ],
  pressureVessels: [
    { label: '设备名称', prop: 'prContainerName', col: 12 },
    { label: '厂内设备编号', prop: 'prContainerNum', col: 12 },
    { label: '专业', prop: 'prProfessional', col: 12 },
    { label: '制造单位', prop: 'prEqManufacturingUnit', col: 12 },
    { label: '容器制造日期', prop: 'prEqManufacturingDate', col: 12 },
    { label: '压力容器类别', prop: 'prEqContainerType', col: 12 },
    { label: '产品编号', prop: 'prEqManufacturingNum', col: 12 },
    { label: '设备出厂附件', prop: 'prEqManufacturingFile', col: 24, type: 'attachment' },
    { label: '设计压力（Mpa）', prop: 'prEqDesiPressure', col: 12 },
    { label: '设计温度（℃）', prop: 'prEqDesiTemperature', col: 12 },
    { label: '最高运行温度（℃）', prop: 'prEqWorkingMaxTemperature', col: 12 },
    { label: '最高运行压力（Mpa）', prop: 'prEqWorkingMaxPressure', col: 12 },
    { label: '介质', prop: 'prEqWorkingMedia', col: 12 },
    { label: '规格（ψ*h*w）mm', prop: 'prEqSpecificationsThw', col: 12 },
    { label: '容积（m³）', prop: 'prEqSpecificationsVolume', col: 12 },
    { label: '材质', prop: 'prEqSpecificationsMaterial', col: 12 },
    { label: '设备编号', prop: 'prEqNum', col: 12 },
    { label: '设备代码', prop: 'prEqCode', col: 12 },
    { label: '压力容器注册资料', prop: 'prRegistInfo', col: 24, type: 'attachment' },
    { label: '注册登记证发放日期', prop: 'prRegistCertificateDate', col: 12 },
    { label: '注册登记证编号', prop: 'prRegistCertificateNum', col: 12 },
    {
      label: '注册使用登记证附件',
      prop: 'prRegistCertificateFile',
      col: 24,
      type: 'attachment',
    },
    { label: '年度检查日期', prop: 'prYearInspectDate', col: 12 },
    { label: '年度检验到期日', prop: 'prYearInspectDueDate', col: 12 },
    { label: '年度检验报告', prop: 'prYearInspectReport', col: 24, type: 'attachment' },
    { label: '定期检验日期', prop: 'prRegularInspectDate', col: 12 },
    { label: '定期检验到期日', prop: 'prRegularInspectDueDate', col: 12 },
    { label: '定期检验报告', prop: 'prRegularInspectReport', col: 24, type: 'attachment' },
    { label: '安装位置', prop: 'prEqInstallLocation', col: 12 },
    { label: '安装单位', prop: 'prEqInstallUnit', col: 12 },
    { label: '设备投用时间', prop: 'prEqInstallDate', col: 12 },
  ],
  simplePressureVessels: [
    { label: '设备名称', prop: 'prContainerName', col: 12 },
    { label: '厂内设备编号', prop: 'prContainerNum', col: 12 },
    { label: '专业', prop: 'prProfessional', col: 12 },
    { label: '安装位置', prop: 'prEqInstallLocation', col: 12 },
    { label: '推荐使用寿命', prop: 'prEqEffectAge', col: 12 },
    { label: '设备使用到期日', prop: 'prEqMaturityDate', col: 12 },
    { label: '制造单位', prop: 'prEqManufacturingUnit', col: 12 },
    { label: '容器制造日期', prop: 'prEqManufacturingDate', col: 12 },
    { label: '产品编号', prop: 'prEqManufacturingNum', col: 12 },
    { label: '出厂设备资料', prop: 'prEqManufacturingFile', col: 24, type: 'attachment' },
    { label: '设计温度（℃）', prop: 'prEqDesiTemperature', col: 12 },
    { label: '设计压力（Mpa）', prop: 'prEqDesiPressure', col: 12 },
    { label: '容积（m³）', prop: 'prEqSpecificationsVolume', col: 12 },
    { label: '工作介质', prop: 'prEqWorkingMedia', col: 12 },
    { label: '定期检验日期', prop: 'prRegularInspectDate', col: 12 },
    { label: '定期检验到期日', prop: 'prRegularInspectDueDate', col: 12 },
    { label: '定期检验报告', prop: 'prRegularInspectReport', col: 24, type: 'attachment' },
  ],
  pressureCylinders: [
    { label: '设备名称', prop: 'prCylinderName', col: 12 },
    { label: '存放位置', prop: 'prEqInstallLocation', col: 12 },
    { label: '专业', prop: 'prProfessional', col: 12 },
    { label: '制造单位', prop: 'prEqManufacturingUnit', col: 12 },
    { label: '钢瓶编号', prop: 'prEqManufacturingNum', col: 12 },
    { label: '设备出厂附件', prop: 'prEqManufacturingFile', col: 24, type: 'attachment' },
    { label: '制造日期', prop: 'prEqManufacturingDate', col: 12 },
    { label: '公称压力（Mpa）', prop: 'prEqWorkingMaxPressure', col: 12 },
    { label: '有效容积（m³）', prop: 'prEqSpecificationsVolume', col: 12 },
    { label: '充装介质', prop: 'prEqWorkingMedia', col: 12 },
    { label: '设备编号', prop: 'prEqNum', col: 12 },
    { label: '设备代码', prop: 'prEqCode', col: 12 },
    { label: '压力气瓶注册资料附件', prop: 'prRegistInfo', col: 24, type: 'attachment' },
    { label: '注册登记证发放日期', prop: 'prRegistCertificateDate', col: 12 },
    { label: '注册登记证编号', prop: 'prRegistCertificateNum', col: 12 },
    { label: '注册使用登记证附件', prop: 'prRegistCertificateFile', col: 24, type: 'attachment' },
    { label: '定期检验日期', prop: 'prRegularInspectDate', col: 12 },
    { label: '定期检验到期日', prop: 'prRegularInspectDueDate', col: 12 },
    { label: '定期检验报告', prop: 'prRegularInspectReport', col: 24, type: 'attachment' },
  ],
  boiler: [
    { label: '设备名称', prop: 'prBoilerName', col: 12 },
    { label: '厂内设备编号', prop: 'prBoilerNum', col: 12 },
    { label: '锅炉制造单位', prop: 'prEqManufacturingUnit', col: 12 },
    { label: '锅炉型号', prop: 'prEqContainerType', col: 12 },
    { label: '产品编号', prop: 'prEqManufacturingNum', col: 12 },
    { label: '锅炉制造日期', prop: 'prEqManufacturingDate', col: 12 },
    { label: '设备出厂附件', prop: 'prEqManufacturingFile', col: 24, type: 'attachment' },
    { label: '安装单位', prop: 'prEqInstallUnit', col: 12 },
    { label: '设备投用时间', prop: 'prEqInstallDate', col: 12 },
    {
      label: '安装监督检验检查文件资料包',
      prop: 'prEqInstallFile',
      col: 24,
      type: 'attachment',
      labelWidth: 200,
    },
    { label: '设计压力（Mpa）', prop: 'prEqDesiPressure', col: 12 },
    { label: '设计温度（℃）', prop: 'prEqDesiTemperature', col: 12 },
    { label: '最高运行温度（℃）', prop: 'prEqWorkingMaxTemperature', col: 12 },
    { label: '最高运行压力（Mpa）', prop: 'prEqWorkingMaxPressure', col: 12 },
    { label: '介质种类', prop: 'prEqWorkingMedia', col: 12 },
    { label: '设备编号', prop: 'prEqNum', col: 12 },
    { label: '设备代码', prop: 'prEqCode', col: 12 },
    { label: '锅炉注册资料附件', prop: 'prRegistInfo', col: 24, type: 'attachment' },
    { label: '锅炉外检日期', prop: 'prOuterInspectDate', col: 12 },
    { label: '锅炉外检到期日', prop: 'prOuterIinspectDueDate', col: 12 },
    { label: '锅炉外检报告', prop: 'prOuterIinspectReport', col: 24, type: 'attachment' },
    { label: '锅炉内检日期', prop: 'prInnerInspectDate', col: 12 },
    { label: '锅炉内检到期日', prop: 'prInnerInspectDueDate', col: 12 },
    { label: '锅炉内检报告', prop: 'prInnerInspectReport', col: 24, type: 'attachment' },
  ],
  reliefValve: [
    { type: 'dividingLine', prop: '基础信息' },
    { label: '工作名称', prop: 'prReliefValveName', col: 8 },
    { label: '项次', prop: 'prSerialNo', col: 8 },
    { label: '专业', prop: 'prProfessional', col: 8 },
    { label: '区域', prop: 'prArea', col: 8 },
    { label: '设备编号', prop: 'prEqNum', col: 8 },
    {
      label: '安全阀类型',
      prop: 'prReliefValveEqType',
      col: 8,
      type: 'dataCategory',
      dataCategory: { 1: '重锤式', 2: '先导式', 3: '弹簧式' },
    },
    { label: '安全阀型号', prop: 'prReliefValveCode', col: 8 },
    {
      label: '安全阀型式',
      prop: 'prReliefValveType',
      col: 8,
      type: 'dataCategory',
      dataCategory: { 1: '微启式', 2: '全启式' },
    },
    { label: '安全阀名称', prop: 'prReliefValveName', col: 8 },
    { label: '安装位置', prop: 'prInstallLocation', col: 8 },
    { label: '工作压力', prop: 'prWorkPressure', col: 8 },
    { label: '设计压力', prop: 'prDesiPressure', col: 8 },
    { label: '要求整定压力MPA（G）', prop: 'prRequirePressure', col: 8 },
    { label: '工作介质', prop: 'prWorkMedia', col: 8 },
    { label: '介质温度', prop: 'prWorkMediaTemperature', col: 8 },
    { label: '阀杆是否外露', prop: 'prIsLeakage', col: 8 },
    { label: '制造单位', prop: 'prManufacturingUnit', col: 8 },
    { type: 'dividingLine', prop: '入口型式及尺寸' },
    { label: '型式', prop: 'prEntranceType', col: 8 },
    { label: '公称通径', prop: 'prEntranceDiameter', col: 8 },
    { label: '公称压力', prop: 'prEntrancePressure', col: 8 },
    { type: 'dividingLine', prop: '安全阀检验信息' },
    { label: '检验委托日期', prop: 'prInspectWtDate', col: 8 },
    { label: '委托单编号', prop: 'prWtNum', col: 8 },
    { label: '校验方式', prop: 'prInspectType', col: 8 },
    { label: '校验日期', prop: 'prInspectDate', col: 10 },
    { label: '校验到期日期', prop: 'prInspectDueDate', col: 10 },
    { label: '安全阀校验报告', prop: 'prReliefValveReportFile', col: 24, type: 'attachment' },
    { label: '备注', prop: 'prRemarks', col: 24 },
  ],
  // 支吊架
  supportHanger: [
    { label: '设备名称', prop: 'prName', col: 12 },
    { label: '燃气机编号', prop: 'prNum', col: 12 },
    { label: '机组类别', prop: 'prGroupType', col: 12 },
    { label: '专业', prop: 'prProfessional', col: 12 },
    { label: '全面检验到期日', prop: 'prAllInspectDueDate', col: 12 },
    { label: '安装时间', prop: 'prInstallDate', col: 12 },
    { label: '全面检验日期', prop: 'prAllInspectDate', col: 12 },
    { label: '年度检验到期日', prop: 'prYearInspectDueDate', col: 12 },
    { label: '安装单位', prop: 'prInstallUnit', col: 12 },
    { label: '热态检查时间', prop: 'prHotTestTime', col: 12 },
    { label: '冷态检查时间', prop: 'prColdTestTime', col: 12 },
    {
      label: '支吊架图纸台账',
      prop: 'prDrawingFile',
      col: 24,
      type: 'attachment',
    },
    {
      label: '支吊架基础信息台账',
      prop: 'prBaseInfoFile',
      col: 24,
      type: 'attachment',
    },
  ],
}

export default {
  ...inspectionConfig,
}
